// extracted by mini-css-extract-plugin
export default {"rating":"XK-z","numberOfStars":"YK-z","count":"ZK-z","barGraphSpacing":"_K-z","barGraph":"aL-z"};